import { Box, type ChakraProps, useColorModeValue } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

export function Card(props: ChakraProps & PropsWithChildren) {
  const cardBackground = useColorModeValue('gray.50', 'gray.700');
  const { children, ...rest } = props;
  return (
    <Box background={cardBackground} width='full' p={{ base: 3, md: 4 }} borderRadius='md' {...rest}>
      {children}
    </Box>
  );
}
